<template>
  <div class="ui segments">
    <!-- dimmer -->
    <div v-if="isLoading" class="ui active inverted dimmer timeline-dimmer">
      <div class="ui loader"></div>
    </div>
    <div class="ui clearing segment header">
      <span class="left floated title">Timeline Trend</span>

      <!-- Help and download -->
      <span class="icons right floated">
        <help-icon :content="help"></help-icon>
        <download-export-button
          :name="`${currentAnalysis.name}-Timeline`"
          :is-loading="isLoading"
          :get-el="getTrendEl"
          :get-svg-export-config="getExportConfig"
          :basic-svg-export="true"
          short-name="Timeline"
        >
        </download-export-button>
      </span>

      <!-- Normalisation options -->
      <div class="header-buttons right floated">
        <div class="ui buttons">
          <button class="ui button" :class="{ active : mode === 'normalised' }" @click="mode = 'normalised'">
            Normalized
          </button>
          <button class="ui button" :class="{ active : mode === 'raw' }" @click="mode = 'raw'">
            Raw Freq.
          </button>
        </div>
      </div>
    </div>

    <div class="ui segment">
      <div class="ui horizontal list dropdowns">
        <div class="item">
          <span id="field" class="variable-select-timeline">
            <div class="dropdown-label">
              Field:
            </div>
            <div class="ui scrolling dropdown">
              <div class="text">{{ field }}</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div v-for="(variableName, index) in currentModel.dateFields" :key="index" class="item" :data-value="variableName.name">
                  {{ variableName.name }}
                </div>
              </div>
            </div>
          </span>
        </div>

        <div class="item">
          <span id="resolution" class="variable-select-timeline">
            <div class="dropdown-label">
              Resolution:
            </div>
            <div class="ui scrolling dropdown">
              <div class="text">Monthly</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div class="item" data-value="daily">Daily</div>
                <div class="item" data-value="weekly">Weekly</div>
                <div class="item" data-value="monthly">Monthly</div>
                <div class="item" data-value="yearly">Yearly</div>
              </div>
            </div>
          </span>
        </div>
      </div>

      <!-- Render topic timeline -->
      <div id="timeline-container">
        <template v-if="timelineData">
          <div ref="timeline-trend" class="timeline"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'

import HelpIcon from 'src/components/project/analysis/results/widgets/HelpIcon.vue'
import DownloadExportButton from 'src/components/project/analysis/results/widgets/DownloadExportButton.vue'
import TimelineTrendBase from 'src/components/project/analysis/results/widgets/TimelineTrendBase.vue'

export default defineComponent({
  components: { HelpIcon, DownloadExportButton },
  extends: TimelineTrendBase,
  data () {
    return {
      field: this.$store.getters.defaultDateField
    }
  },
  computed: {
    ...mapGetters([
      'currentAnalysis', 'analysisTimeline', 'currentModel', 'defaultDateField',
    ]),
    help () {
      return `<p>Graphs the trajectory of this query over time.</p>
              <p><b>Note:</b> Your data must contain a time label for this to work effectively</p>`
    }
  },
})
</script>

<style lang="sass" scoped>
  .header .left.floated
    float: left
  .header
    padding: 0 !important
    .title
      padding: 1em
    ::v-deep .header-buttons
      padding: 10px 20px !important
      .button.active, .button:hover
        background: rgba(149, 166, 172, 1)
        color: white
      .button
        background: rgba(149, 166, 172, 0.15)
        border: 1px solid rgba(149, 166, 172, 0.4) !important
        color: rgb(149, 166, 172)
        font-weight: bold
        width: 115px
        &:first-child
          border-right: 0 !important
      .ui.buttons .button:first-child
        border-top-left-radius: .28571429rem
        border-bottom-left-radius: .28571429rem
      .ui.buttons .button:last-child
        border-top-right-radius: .28571429rem
        border-bottom-right-radius: .28571429rem
</style>